<template>
  <div>
    <span v-if="isHeaderVisible">
      <span class="small-text">{{ $getText('PRESENCE_OUT_DOOR_ACTIVITIES') }}</span>
      <div class="border-bottom" />
    </span>
    <div class="presence-icons">
      <div v-if="isFieldTripVisible" class="presence-icon-container">
        <IconContainer
          v-button
          class="icon-circle"
          :class="{ active: status == presenceStates.FIELDTRIP }"
          :aria-label="$getText('ARIA_LABEL_CHOOSE_FIELD_TRIP')"
          @click="
            updateFieldTrip(status != presenceStates.FIELDTRIP ? presenceStates.FIELDTRIP : presenceStates.PRESENT)
          "
        >
          <Icon :name="iconClassEnum.BACKPACK" />
        </IconContainer>
        <div class="icons-description">
          {{ $getText('PRESENCE_FIELDTRIP') }}
        </div>
      </div>
      <div v-if="isSpareTimeVisible" class="presence-icon-container">
        <IconContainer
          v-button
          class="icon-circle"
          :class="{
            active: status == presenceStates.SPARE_TIME_ACTIVITY,
            disabled: !configuration[presenceModules.SPARE_TIME_ACTIVITY].editable,
          }"
          :aria-label="$getText('ARIA_LABEL_CHOOSE_SPARE_ACTIVITY')"
          @click="
            updateSpareActivity(
              status != presenceStates.SPARE_TIME_ACTIVITY ? presenceStates.SPARE_TIME_ACTIVITY : presenceStates.PRESENT
            )
          "
        >
          <Icon :name="iconClassEnum.WALKING_PERSON" />
        </IconContainer>
        <div class="icons-description">
          {{ $getText('PRESENCE_SPARE_TIME_ACTIVITY') }}
        </div>
      </div>
      <div v-if="isCommentVisible" class="activity-comment">
        <strong>{{ $getText('PRESENCE_SPARE_TIME_ACTIVITY_NOTE') }}</strong
        ><br />
        {{ comment }}
      </div>
    </div>
  </div>
</template>
<script>
import { presenceStates } from '../../enums/presenceStates';
import { presenceModules } from '../../enums/presenceModules';
import IconContainer from '../IconContainer.vue';
import Icon from '../Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import button from '../../directives/button';

export default {
  components: { Icon, IconContainer },
  directives: {
    button,
  },
  props: {
    status: { type: Number },
    comment: { type: String, default: null },
    configuration: { type: Object, default: () => {} },
  },
  data: function () {
    return {
      presenceStates: presenceStates,
      presenceModules: presenceModules,
      showVacationForm: false,
    };
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    isFieldTripVisible() {
      return (
        this.configuration[presenceModules.FIELD_TRIP] != null &&
        this.configuration[presenceModules.FIELD_TRIP].readable
      );
    },
    isSpareTimeVisible() {
      return (
        this.configuration[presenceModules.SPARE_TIME_ACTIVITY] != null &&
        this.configuration[presenceModules.SPARE_TIME_ACTIVITY].readable
      );
    },
    isCommentVisible() {
      return this.comment != null && this.comment != '';
    },
    isHeaderVisible() {
      return this.isCommentVisible || this.isSpareTimeVisible || this.isFieldTripVisible;
    },
  },
  methods: {
    updateFieldTrip(status) {
      if (this.configuration[presenceModules.FIELD_TRIP].editable) {
        this.$emit('updateChildStatus', status);
      }
    },
    updateSpareActivity(status) {
      if (this.configuration[presenceModules.SPARE_TIME_ACTIVITY].editable) {
        this.$emit('updateChildStatus', status);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@use '../../assets/scss/core/variables' as *;
@use '../../assets/scss/core/breakpoints' as *;
@use '../../assets/scss/components/presence/presence-checkin-dashboard' as *;
</style>
